// extracted by mini-css-extract-plugin
module.exports = {"concretedOperationsTable":"concretedOperationsTable_concretedOperationsTable__NYRgn"};